(function () {
    'use strict';
    angular
        .module('ipmApp')
        .factory('BatteryTestingService', BatteryTestingService);

    BatteryTestingService.$inject = ['$resource', '$q', 'halClient', '$http'];

    function BatteryTestingService($resource, $q, halClient, $http) {
        var baseUrl = 'api/haq-battery';

        var service = {
            'saveBatteryTesting': saveBatteryTesting,
            'deleteBatteryTesting': deleteBatteryTesting
        };

        function saveBatteryTesting(haqBattery) {
            var url = baseUrl + '/create';
            return $http.post(url, haqBattery).then(function (resp) {
                return resp.data;
            });
        }

        function deleteBatteryTesting(surveyResultId) {
            if(!surveyResultId){
                return;
            }
            var url = baseUrl + '/delete/' + surveyResultId;
            return $http.delete(url).then(function (resp) {
                return resp.data;
            });
        }
        return service;
    }
})();
